import React from 'react';
import PageLayout from '../components/layout/PageLayout';

const PlayerGuidePage = () => {
  return (
    <PageLayout headerTitle="Spelguide" maxWidth="max-w-4xl">
      <div className="space-y-8 pb-8">
        {/* Hero */}
        <div className="rounded-2xl border border-cyan-500/40 bg-slate-900/60 p-8">
          <h1 className="text-4xl font-bold text-white mb-2">Quizter – Spelguide</h1>
          <p className="text-slate-400 text-sm">Snabb bruksanvisning för spelare.</p>
        </div>

        {/* 1. Översikt */}
        <section className="rounded-2xl border border-slate-700 bg-slate-900/60 p-6">
          <h2 className="text-2xl font-bold text-white mb-4 pb-3 border-b border-slate-700">
            1. Översikt
          </h2>
          <p className="text-slate-300 mb-4">
            Quizter låter dig skapa och spela digitala tipsrundor direkt i webbläsaren.
          </p>
          <div className="bg-cyan-500/10 border border-cyan-500/40 rounded-lg p-4">
            <p className="text-cyan-300">
              <strong className="text-cyan-400">Snabbt:</strong> Skapa en runda, dela koden och börja spela.
            </p>
          </div>
        </section>

        {/* 2. Skapa runda */}
        <section className="rounded-2xl border border-slate-700 bg-slate-900/60 p-6">
          <h2 className="text-2xl font-bold text-white mb-4 pb-3 border-b border-slate-700">
            2. Skapa runda
          </h2>
          <p className="text-slate-300 mb-4">
            Välj rundtyp, antal frågor och svårighet. När rundan är skapad får du en kod att dela.
          </p>
          <figure className="my-6">
            <img
              src="/manual-images/generate-run.png"
              alt="Skapa runda"
              className="w-full rounded-lg border border-slate-600"
            />
            <figcaption className="text-sm text-slate-400 mt-3">
              Skapa runda: välj typ, frågor och inställningar.
            </figcaption>
          </figure>
        </section>

        {/* 3. Anslut till runda */}
        <section className="rounded-2xl border border-slate-700 bg-slate-900/60 p-6">
          <h2 className="text-2xl font-bold text-white mb-4 pb-3 border-b border-slate-700">
            3. Anslut till runda
          </h2>
          <p className="text-slate-300 mb-4">
            Skriv in koden som skaparen delat. Du ansluts direkt till spelet.
          </p>
          <figure className="my-6">
            <img
              src="/manual-images/join-run.png"
              alt="Anslut till runda"
              className="w-full rounded-lg border border-slate-600"
            />
            <figcaption className="text-sm text-slate-400 mt-3">
              Anslut med kod för att gå med i en runda.
            </figcaption>
          </figure>
        </section>

        {/* 4. Spela & resultat */}
        <section className="rounded-2xl border border-slate-700 bg-slate-900/60 p-6">
          <h2 className="text-2xl font-bold text-white mb-4 pb-3 border-b border-slate-700">
            4. Spela & resultat
          </h2>
          <ul className="space-y-2 mb-4 text-slate-300">
            <li className="flex items-start">
              <span className="text-cyan-400 mr-2">•</span>
              Svara på frågor när de blir tillgängliga.
            </li>
            <li className="flex items-start">
              <span className="text-cyan-400 mr-2">•</span>
              Vid tid‑baserad runda visas nedräkning till nästa fråga.
            </li>
            <li className="flex items-start">
              <span className="text-cyan-400 mr-2">•</span>
              Efter sista frågan visas resultat och placering.
            </li>
          </ul>

          <figure className="my-6">
            <img
              src="/manual-images/landing.png"
              alt="Startsida"
              className="w-full rounded-lg border border-slate-600"
            />
            <figcaption className="text-sm text-slate-400 mt-3">
              Startsidan med snabb åtkomst till spel.
            </figcaption>
          </figure>
        </section>

        {/* 5. Tips */}
        <section className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-6">
          <h2 className="text-2xl font-bold text-emerald-400 mb-4 pb-3 border-b border-emerald-500/20">
            5. Tips
          </h2>
          <ul className="space-y-2 text-slate-300">
            <li className="flex items-start">
              <span className="text-emerald-400 mr-2">💡</span>
              Om du tappar anslutningen: ladda om sidan och gå med via koden igen.
            </li>
            <li className="flex items-start">
              <span className="text-emerald-400 mr-2">💡</span>
              Vid tidsbaserade rundor: håll fliken aktiv för att se nästa fråga i tid.
            </li>
          </ul>
        </section>

        <p className="text-center text-slate-500 text-sm">
          Dokumentet är genererat internt för Quizter.
        </p>
      </div>
    </PageLayout>
  );
};

export default PlayerGuidePage;
